import React from "react";

/**
 * ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {string} icon アイコン名
 * @param {boolean} disabled 押下不可かどうか
 * @param {Function} onClick ボタン押下時の処理
 * @param {string} className クラス名
 * @class Button
 */
export default function ChipButton({ title, onClick, className = "" }) {
  return (
    <button className={`chip-btn ${className}`} onClick={onClick}>
      {title}
    </button>
  );
}
